(() => {
  if (customElements.get('m90-quick-dorsal-field')) {
    return;
  }

  class M90QuickDorsalField extends HTMLElement {
    connectedCallback() {
      if (this.dataset.m90Ready === 'true') {
        return;
      }

      this.dataset.m90Ready = 'true';

      this.input = this.querySelector(
        '[data-m90-quick-dorsal-input]'
      );

      this.error = this.querySelector(
        '[data-m90-quick-dorsal-error]'
      );

      if (!this.input) {
        return;
      }

      /*
       * Solo debe funcionar dentro
       * del modal de Agregado rápido.
       */
      this.dialog =
        this.closest('quick-add-dialog') ||
        this.closest('#quick-add-dialog');

      if (!this.dialog) {
        this.hidden = true;
        this.input.required = false;
        this.input.removeAttribute('name');
        this.input.removeAttribute('disabled');
        return;
      }

      this.productForm = this.closest(
        'product-form-component'
      );

      this.productId = String(
        this.productForm?.dataset.productId || ''
      );

      this.handleChange = () => {
        /*
         * Horizon actualiza algunas partes
         * inmediatamente y otras de forma asíncrona.
         */
        requestAnimationFrame(() => {
          this.sync();
        });

        window.setTimeout(() => {
          this.sync();
        }, 80);

        window.setTimeout(() => {
          this.sync();
        }, 250);
      };

      this.handleInput = () => {
        this.input.setCustomValidity('');
        this.input.removeAttribute('aria-invalid');

        if (this.error) {
          this.error.hidden = true;
        }
      };

      this.handleInvalid = () => {
        if (!this.requiresDorsal()) {
          return;
        }

        this.input.setCustomValidity(
          'Ingresa el nombre y número del dorsal.'
        );

        this.input.setAttribute(
          'aria-invalid',
          'true'
        );

        if (this.error) {
          this.error.hidden = false;
        }
      };

      /*
       * Escuchamos cualquier cambio de variante
       * dentro del modal.
       */
      this.dialog.addEventListener(
        'change',
        this.handleChange,
        true
      );

      this.input.addEventListener(
        'input',
        this.handleInput
      );

      this.input.addEventListener(
        'invalid',
        this.handleInvalid
      );

      /*
       * Horizon puede reconstruir partes del modal.
       * Si ocurre, volvemos a comprobar Dorsal.
       */
      this.observer = new MutationObserver(() => {
        window.clearTimeout(this.m90MutationTimer);

        this.m90MutationTimer =
          window.setTimeout(() => {
            this.sync();
          }, 40);
      });

      this.observer.observe(
        this.dialog,
        {
          childList: true,
          subtree: true
        }
      );

      this.sync();

      window.setTimeout(() => {
        this.sync();
      }, 150);
    }

    disconnectedCallback() {
      this.dialog?.removeEventListener(
        'change',
        this.handleChange,
        true
      );

      this.input?.removeEventListener(
        'input',
        this.handleInput
      );

      this.input?.removeEventListener(
        'invalid',
        this.handleInvalid
      );

      this.observer?.disconnect();

      window.clearTimeout(
        this.m90MutationTimer
      );
    }

    normalize(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();
    }

    getVariantPicker() {
      const pickers = Array.from(
        this.dialog.querySelectorAll(
          'variant-picker'
        )
      );

      if (this.productId) {
        const matchingPicker =
          pickers.find((picker) => {
            return (
              String(picker.dataset.productId || '') ===
              this.productId
            );
          });

        if (matchingPicker) {
          return matchingPicker;
        }
      }

      return pickers[0] || null;
    }

    getDorsalValue() {
      const picker = this.getVariantPicker();

      if (!picker) {
        return '';
      }

      /*
       * Selector de variantes con botones.
       * Horizon coloca data-option-name
       * directamente en cada radio.
       */
      const checkedInputs = Array.from(
        picker.querySelectorAll(
          'input[type="radio"][data-option-name]:checked'
        )
      );

      const dorsalRadio =
        checkedInputs.find((input) => {
          return (
            this.normalize(
              input.dataset.optionName
            ) === 'dorsal'
          );
        });

      if (dorsalRadio) {
        return dorsalRadio.value;
      }

      /*
       * Compatibilidad si después cambias
       * las variantes a desplegables.
       */
      const selects = Array.from(
        picker.querySelectorAll('select')
      );

      for (const select of selects) {
        const selected =
          select.selectedOptions?.[0];

        const optionName =
          selected?.dataset.optionName ||
          select
            .getAttribute('name')
            ?.replace(/^options\[/, '')
            .replace(/\]$/, '');

        if (
          this.normalize(optionName) ===
          'dorsal'
        ) {
          return select.value;
        }
      }

      return '';
    }

    requiresDorsal() {
      return (
        this.normalize(
          this.getDorsalValue()
        ) === 'con dorsal'
      );
    }

    sync() {
      const required =
        this.requiresDorsal();

      /*
       * CON DORSAL
       */
      if (required) {
        this.hidden = false;

        /*
         * El cliente SIEMPRE puede escribir.
         */
        this.input.disabled = false;

        /*
         * Se enviará al carrito como
         * propiedad personalizada.
         */
        this.input.name =
          'properties[Nombre y número]';

        this.input.required = true;

        return;
      }

      /*
       * SIN DORSAL
       */
      this.hidden = true;

      this.input.disabled = false;
      this.input.required = false;

      /*
       * Sin name no se envía a Shopify.
       */
      this.input.removeAttribute('name');

      this.input.setCustomValidity('');

      this.input.removeAttribute(
        'aria-invalid'
      );

      if (this.error) {
        this.error.hidden = true;
      }
    }
  }

  customElements.define(
    'm90-quick-dorsal-field',
    M90QuickDorsalField
  );
})();